<!-- <p>resultado-eleicao works!</p> -->



<p align="right">
  <button class="btn btn-outline-secondary" (click)="volta()">Voltar</button>
</p>
<app-table-resultado-eleicao [eleicaoId]="idEleicao" ></app-table-resultado-eleicao>